import {Injectable} from "@angular/core"
import {NodeEditorTransform} from "@node-editor/helpers/navigation"
import {NavigationOptions, Point} from "@node-editor/types/navigation"

@Injectable({
    providedIn: "root",
})
export class NodeEditorTransformService {
    transform?: NodeEditorTransform

    public register(parent: HTMLElement, child: HTMLElement, options?: NavigationOptions) {
        this.transform = new NodeEditorTransform(parent, child, options)
        return this.transform
    }

    get scale() {
        return this.transform!.scale
    }

    public viewportToLogicalCoordinates = (point: Point) => {
        return this.transform!.viewportToLogicalCoordinates(point)
    }
    public logicalToViewportCoordinates = (point: Point) => {
        return this.transform!.logicalToViewportCoordinates(point)
    }

    public editorToLogicalCoordinates = (point: Point) => {
        return this.transform!.editorToLogicalCoordinates(point)
    }
    public logicalToEditorCoordinates = (point: Point) => {
        return this.transform!.logicalToEditorCoordinates(point)
    }
}
